var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCampFire = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.833,
    height: 44.769,
    viewBox: "0 0 37.833 44.769",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.986 -1031.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.405,1064.039a15.714,15.714,0,0,1-5.526-4.947,14.041,14.041,0,0,1-1.5-7s4.638-1.7,6.856,1.71c0,0-3.241-2.388-.17-9.211s10.414-12.111,10.414-12.111-2.934,8.044-1.373,9.211c.043.163,2.245-1.556,2.44-1.1.781,1.96,1.657,7.567,3,2.667,0,0,3.734.534,4.112,6.45s-1.112,6.717-1.112,6.717l5-2.623s-.988,12.622-9.347,13.817H44.545",
    transform: "translate(2.077 2.237)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.647,1056.276H28.254a3.517,3.517,0,0,0-3.518,3.517h0a3.517,3.517,0,0,0,3.518,3.518h26.29",
    transform: "translate(0 12.134)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.575,1056.276h0a5.036,5.036,0,0,1,.738,6.371l-.337.536",
    transform: "translate(2.452 12.134)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.434,1056.36h6.653v6.653",
    transform: "translate(9.982 12.177)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.431,
    cy: 2.431,
    r: 2.431,
    transform: "translate(54.544 1041.799)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.407,
    cy: 1.407,
    r: 1.407,
    transform: "translate(51.858 1037.322)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.407,
    cy: 1.407,
    r: 1.407,
    transform: "translate(26.858 1070.322)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.407,
    cy: 1.407,
    r: 1.407,
    transform: "translate(55.312 1032.332)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.458,1059.9s-3.048-3.9,1.524-10.331c0,0,5.25,3.048,2.711,10.331",
    transform: "translate(4.494 6.207)",
    fill: "none",
    stroke: "#3d5567",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCampFire, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camp-fire.5b9a2fea.svg";
export { ForwardRef as ReactComponent };